import { useContext } from 'react'
import { StoreContext } from '@/lib/store'
import { tokenParam } from './interface';


const isTokenExist = async () => {
  let cookie = '';
  const cookieName = 'CookieTheRock';
  const theCookie = '' + document.cookie;
  // console.log(theCookie)
  const ind = theCookie.indexOf(cookieName);
  let ind1 = theCookie.indexOf(';', ind);
  if (ind1 === -1) ind1 = theCookie.length;
  if (ind === -1) cookie = '';
  cookie = await unescape(theCookie.substring(ind + cookieName.length + 1, ind1));
  if (cookie == '') {
    throw new Error("Cookie not found");
  }
  return await cookie
}

const isCookieValid = async (cookie: any) => {
  cookie = cookie.replace(/['"]+/g, '');
  // console.log(cookie)
  cookie = cookie.substring(cookie.indexOf('{', 0));
  // console.log(cookie)
  cookie = cookie.substring(1, cookie.length);
  // console.log(cookie)
  cookie = cookie.substring(0, cookie.length - 1);
  // console.log(cookie)
  let token = cookie.split(';').map(item => {
    return item.split(':');
  });

  if (typeof token[3] == 'undefined') {
    throw new Error("cookie token [3] not found");
  }

  if (typeof token[3][2] == 'undefined') {
    throw new Error("cookie token [3][2] not found");
  }

  return await token[3][2]
}

const CheckAuth = async () => {

  const store = useContext(StoreContext);
  const { validateAdmin } = store.authStore

  return new Promise(async function (resolve, reject) {
    try{
      const cookie = await isTokenExist();
      // console.log(cookie)
      
      const validCookie = await isCookieValid(cookie)
      // console.log(validCookie)
  
      let param: tokenParam = {
        TOKEN: String(validCookie)
      }
  
      const isAdmin = await validateAdmin(param);
      // console.log(isAdmin)
  
      resolve(isAdmin)
    }
    catch{
      reject(false)
    }
    
  })

}

export const GetAuth = () => {
  
  const auth = CheckAuth()

  return auth
}